import { createApp, h } from 'vue';
import { createPinia } from 'pinia';
import { useFavouritesStore } from '../vue/store/index';

// Create a single Pinia instance to be shared across all Vue apps
const pinia = createPinia();

function initSingle(el, component, globalComponents = {}) {
  const propsValue = el.getAttribute('data-vue-props');
  let props = propsValue ? JSON.parse(propsValue) : {};
  
  // Ensure props is always a plain object, not an array
  // (Vue 3's h() function requires props to be an object)
  if (Array.isArray(props) || typeof props !== 'object' || props === null) {
    props = {};
  }

  // Vue 3 mounting behavior change: Vue 3 mounts INSIDE the element instead of replacing it.
  // Since we use <script> tags (which have display:none), we need to replace them with <div> elements.
  let mountEl = el;
  if (el.tagName.toLowerCase() === 'script') {
    const div = document.createElement('div');
    // Copy relevant attributes
    Array.from(el.attributes).forEach(attr => {
      if (attr.name !== 'type') {
        div.setAttribute(attr.name, attr.value);
      }
    });
    el.parentNode.replaceChild(div, el);
    mountEl = div;
  }

  const app = createApp({
    render() {
      return h(component, props);
    }
  });

  // Use Pinia for state management
  app.use(pinia);

  // Register global components
  Object.entries(globalComponents).forEach(([name, comp]) => {
    app.component(name, comp);
  });

  app.mount(mountEl);

  return app;
}

function init(rootComponents, globalComponents = {}) {
  const elements = document.querySelectorAll('[data-vue-component]');
  const getPriority = el => parseInt(el.getAttribute('data-vue-priority'));
  [...elements]
    .sort((a, b) => getPriority(a) - getPriority(b))
    .forEach((el) => {
      const component = el.getAttribute('data-vue-component');

      if (!rootComponents.hasOwnProperty(component)) {
        console.error(`"${component}" is not a registered Vue root component.`);
        return null;
      }

      initSingle(el, rootComponents[component], globalComponents);
    });
}

// Export pinia for use outside Vue components
export { pinia };

export default {init}
